import { blue, orange, gold, green, red, purple, volcano, cyan } from '@ant-design/colors';

export const SHOPEE_ORANGE = '#EE4D2D';
export const SHOPEE_BLUE = '#0055AA';

/** Grey **/
export const GREY_100 = '#FAFAFA';
export const GREY_200 = '#F5F5F5';
export const GREY_300 = '#E8E8E8';
export const GREY_400 = '#BDBDBD';
export const GREY_500 = '#CCCCCC';
export const GREY_600 = '#757575';
export const GREY_700 = '#595959';

/** Red **/
export const RED_100 = '#FFF4F4';
export const RED_200 = '#EE2C4A';

/** Green **/
export const GREEN_100 = '#E3F4E8';
export const GREEN_200 = '#55CC77';
export const GREEN_300 = '#00BFA5';

export const antdColors = {
  blue,
  orange,
  gold,
  green,
  red,
  purple,
  volcano,
  cyan,
};
